import React from 'react'
import { connect, Provider as ReduxProvider } from 'react-redux'
import { IntlProvider } from 'react-intl'

const Provider = ({ store, ...props }) => {
	return (
		<ReduxProvider store={store}>
			<IntlProvider {...props} />
		</ReduxProvider>
	)
}

const mapStateToProps = state => {
	const { intl } = state
	return { ...intl }
}

export default connect(mapStateToProps)(Provider)
